module.exports = __webpack_public_path__ + "img/klingelbeutel_on_background_violet.a5f53bb0.jpg";